import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { Button, Form, DropdownButton, Dropdown } from "react-bootstrap";
import moment from "moment";
import "moment/locale/nl";
import dayjs from "dayjs";

import ReactPaginate from "react-paginate";
import { RotateLoader } from "react-spinners";

import {
  FaSyncAlt,
  FaTimes,
  FaExternalLinkAlt,
  FaExclamationTriangle,
  FaPrint,
} from "react-icons/fa";
import { GoSearch } from "react-icons/go";
import { IoFilter } from "react-icons/io5";
import { BsShopWindow, BsCalendarDate } from "react-icons/bs";
import { AiOutlineSortAscending } from "react-icons/ai";
import { AuthContext } from "../../context/main/auth-context";
import "../../css/orders/orders.css";

import { downloadBlobFile } from "../../utils/download-blob-file";

import flagNetherlands from "../../images/main/flag-netherlands.svg";
import flagBelgium from "../../images/main/flag-belgium.svg";
import worldGlobe from "../../images/main/world-globe.svg";
import postnlBolMailbox from "../../images/shipping/POSTNL-BOL-MAILBOX.png";
import postnlBolParcel from "../../images/shipping/POSTNL-BOL-PARCEL.png";
import postnlBolParcelPickup from "../../images/shipping/POSTNL-BOL-PARCEL-PICKUP.png";
import postnlBolParcelNight from "../../images/shipping/POSTNL-BOL-PARCEL-NIGHT.png";
import dhlBolMailbox from "../../images/shipping/DHL-BOL-MAILBOX.png";
import dhlBolParcel from "../../images/shipping/DHL-BOL-PARCEL.png";
import dhlBolParcelPickup from "../../images/shipping/DHL-BOL-PARCEL-PICKUP.png";
import dhlBolParcelNight from "../../images/shipping/DHL-BOL-PARCEL-NIGHT.png";

import getAllOpenOrdersFbrDbb from "../../components/bol/get-all-open-orders-fbr-dbb";
import getMultipleShippingLabelsPdf from "../../components/bol/get-multiple-shipping-labels-pdf";
import OrdersHeader from "../../components/orders/orders-header";
import refetchOpenOrders from "../../components/orders/refetch-all-open-orders";
import OrderListItemOpen from "../../components/orders/order-list-item-open";
import getProductBySku from "../../api/mongodb/get-product-by-sku";
import generatePdfPackingSlip from "../../api/backend/generate-pdf-packingslip";
import AssistantToggleButton from "../../components/main/assistant-toggle-button";
import shipOrderItem from "../../components/bol/ship-order-item";
import getProductsBySkus from "../../api/mongodb/get-products-by-skus";


const OrdersFbrDbb = (props) => {
  const { accountSaleNumber } = useParams();
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const startOfToday = dayjs().startOf("day").format();
  const endOfToday = dayjs().endOf("day").format();
  const startOfTomorrow = dayjs().startOf("day").add(1, "day").format();
  const begin2021 = dayjs().year(2021).startOf("year").format();
  const end2099 = dayjs().year(2099).endOf("year").format();

  const sortingNameHandler = (input) => {
    if (input === `{"orderItems.offer.reference":1}`) {
      return "Productgroep (SKU)";
    } else if (input === `{"orderPlacedDateTime":1}`) {
      return "Besteldatum (Oud - Nieuw)";
    } else {
      return "Besteldatum (Nieuw - Oud)";
    }
  };

  const sortingHandler = () => {
    let sortingOrders = JSON.parse(sessionStorage.getItem("openOrdersSorting"));
    if (sortingOrders) {
      return sortingOrders;
    } else {
      return `{"orderPlacedDateTime":-1}`;
    }
  };

  const accountFilterHandler = () => {
    let accountFilter = JSON.parse(
      sessionStorage.getItem("openOrdersFilterByAccount")
    );
    if (accountFilter) {
      return accountFilter;
    } else {
      return `{"$exists":true}`;
    }
  };

  const sortOrders = (sorting) => {
    if (sorting) {
      sessionStorage.setItem("openOrdersSorting", JSON.stringify(sorting));
    }
    setSortOrdersFilter(sorting);
  };

  const filterOrdersByAccount = (accountSaleNumber) => {
    if (accountSaleNumber) {
      sessionStorage.setItem(
        "openOrdersFilterByAccount",
        JSON.stringify(accountSaleNumber)
      );
      setAccountFilter(accountSaleNumber);
    }
  };

  const filetDateNameHandler = (dateRange) => {
    if (dateRange.startDate === begin2021 && dateRange.endDate === endOfToday) {
      return "T/m vandaag";
    } else if (
      dateRange.startDate === startOfTomorrow &&
      dateRange.endDate === end2099
    ) {
      return "Vanaf morgen";
    } else {
      return "Alle orders";
    }
  };

  const dateFilterHandler = () => {
    let dateFilter = JSON.parse(
      sessionStorage.getItem("openOrdersFilterByDate")
    );
    if (dateFilter) {
      return dateFilter;
    } else {
      return { startDate: begin2021, endDate: endOfToday };
    }
  };

  const filterOrdersByDate = (dateRange) => {
    if (dateRange.startDate && dateRange.endDate) {
      sessionStorage.setItem(
        "openOrdersFilterByDate",
        JSON.stringify({
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
        })
      );
      setDateFilter({
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
      });
    }
  };

  const orderHasReadyLabel = (order) => {
    try {
      if (!order?.deliveryOptions?.length) return false;
      const firstOi = order?.orderItems?.[0]?.orderItemId;
      const rel = order.deliveryOptions.find(
        (d) => Array.isArray(d.orderItemIds) && d.orderItemIds.includes(firstOi)
      );
      return !!rel?.chosenOption?.entityId;
    } catch {
      return false;
    }
  };

  const [errorMessage, setErrorMessage] = useState(false);
  const [openOrders, setOpenOrders] = useState([]);
  const [loadingState, setLoadingState] = useState(false);
  const [refetchRemainingTime, setRefetchRemainingTime] = useState(false);
  const [pageCount, setPageCount] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [offset, setOffset] = useState(0);
  const [perPage, setPerPage] = useState(25);
  const [ordersToShow, setOrdersToShow] = useState(false);
  const [checkedOrders, setCheckedOrders] = useState([]);
  const [shipOrdersConfirmDetails, setShipOrdersConfirmDetails] =
    useState(false);
  const [recountOrders, setRecountOrders] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrdersFilter, setSortOrdersFilter] = useState(sortingHandler);
  const [accountFilter, setAccountFilter] = useState(accountFilterHandler);
  const [dateFilter, setDateFilter] = useState(dateFilterHandler);
  const [toggleRefetchOrders, setToggleRefetchOrders] = useState(false);
  const [showAlertText, setShowAlertText] = useState(false);

  // ↓ voeg toe naast je andere useState's
const [filteredOrders, setFilteredOrders] = useState([]);

const showPage = (list, pageIndex = 0) => {
  const start = pageIndex * perPage;
  const end = start + perPage;
  setOrdersToShow(list.slice(start, end));
  setPageCount(Math.ceil(list.length / perPage));
  setCurrentPage(pageIndex);
  setOffset(start);
};

  useEffect(() => {
    (async () => {
      setLoadingState("Bestellingen worden geladen");

      let openOrders = await getAllOpenOrdersFbrDbb(
        auth.token,
        sortOrdersFilter,
        accountFilter,
        dateFilter
      );

      const skus = [
        ...new Set(
          openOrders.orders.flatMap((o) =>
            (o.orderItems || [])
              .map((it) => it?.offer?.reference)
              .filter(Boolean)
              .map(String)
          )
        ),
      ];

      // 2) Batch producten ophalen
      let bySku = {};
      if (skus.length) {
        try {
          const resp = await getProductsBySkus(skus, auth.token); // { products: [...] }
          const products = (resp && resp.products) || [];
          bySku = Object.fromEntries(products.map((p) => [String(p.sku), p]));
        } catch (e) {
          console.warn("SKU enrichment skipped:", e);
        }
      }

      const enrichedOrders = openOrders.orders.map((o) => ({
        ...o,
        orderItems: (o.orderItems || []).map((it) => {
          const sku = String(it?.offer?.reference || "");
          const p = bySku[sku];
          if (!p) return it;

          // pad normaliseren voor je /s3/ route
          const imageKey = (p.image || "")
            .replace(/^\/?s3\//, "")
            .replace(/\s+\/+/g, "/") // "folder ␠ /file" -> "folder/file"
            .trim();

          return {
            ...it,

            // legacy / back-compat: sommige components lezen top-level productData.*
            productData: {
              ...(it.productData || {}),
              _id: p._id,
              title: p.title,
              sku: p.sku,
              ean: p.ean,
              image: imageKey, // ✅ nu aanwezig
            },

            // voorkeursstructuur
            product: {
              ...(it.product || {}),
              title: it.product?.title ?? p.title,
              ean: p.ean ?? it.product?.ean,
              productData: {
                ...(it.product?.productData || {}),
                _id: p._id,
                title: p.title,
                sku: p.sku,
                ean: p.ean,
                image: imageKey, // ✅ nu aanwezig
              },
            },
          };
        }),
      }));

if (openOrders && openOrders.orders && openOrders.orders.length > 0) {
  setOpenOrders(enrichedOrders);
  setFilteredOrders(enrichedOrders);
  showPage(enrichedOrders, 0);      
  setLoadingState(false);
  setErrorMessage(false);
}  else {
        setOpenOrders(0);
        setErrorMessage("Geen openstaande orders gevonden");
        setOrdersToShow(false);
        setLoadingState(false);
      }
    })();
  }, [
    auth.token,
    sortOrdersFilter,
    accountFilter,
    dateFilter,
    toggleRefetchOrders,
  ]);

const handlePageClick = (e) => {
  Array.from(document.querySelectorAll(".o-li-item input, .checkbox-all-orders  input"))
    .forEach((cb) => cb.checked && cb.click());
  setCheckedOrders([]);

  setLoadingState("Bestellingen worden geladen");
  const selectedPage = e.selected;
  showPage(filteredOrders, selectedPage);   // ✅
  setLoadingState(false);
  setSearchQuery("");
};

  const refetchOpenOrdersHandler = async () => {
    setLoadingState("Nieuwe Bestellingen ophalen");

    let fetchedTime = Number(
      sessionStorage.getItem("refetchAllOpenOrdersTime")
    );
    if (fetchedTime && fetchedTime !== null) {
      if (Date.now() - fetchedTime > 60000) {
        setRefetchRemainingTime(false);
        sessionStorage.setItem("refetchAllOpenOrdersTime", Date.now());
        const refetch = await refetchOpenOrders(auth.token);
        if (refetch && refetch.status === 200) {
          window.location.reload(true);
        }
      } else {
        const remainingTime = 60 - (Date.now() - fetchedTime) / 1000;
        setRefetchRemainingTime(remainingTime.toFixed(0));
      }
      setLoadingState(false);
    } else {
      setRefetchRemainingTime(false);
      sessionStorage.setItem("refetchAllOpenOrdersTime", Date.now());
      const refetch = await refetchOpenOrders(auth.token);
      if (refetch && refetch.status === 200) {
        window.location.reload(true);
      }
      setLoadingState(false);
    }
  };

  useEffect(() => {
    if (!refetchRemainingTime) {
      return;
    }
    const interval = setInterval(() => {
      let fetchedTime = Number(
        sessionStorage.getItem("refetchAllOpenOrdersTime")
      );
      const remainingTime = 60 - (Date.now() - fetchedTime) / 1000;
      if (remainingTime >= 0) {
        setRefetchRemainingTime(remainingTime.toFixed(0));
      } else {
        setRefetchRemainingTime(false);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [refetchRemainingTime]);

  const selectionText = () => {
    if (checkedOrders.length === 0) {
      return "(0)";
    } else {
      return "(" + checkedOrders.length + ")";
    }
  };

 const handleCheckedAll = (e) => {
  const allCheckboxes = Array.from(
    document.querySelectorAll(".o-li-item input:not([disabled])")
  );

  if (e.target.checked) {
    // Klik alle checkboxen aan → dit triggert voor elke regel jouw handleChecked(...)
    allCheckboxes.forEach((checkbox) => {
      if (!checkbox.checked) checkbox.click();
    });

    // ⚠️ BELANGRIJK:
    // GEEN setCheckedOrders(...) meer hier.
    // handleChecked vult checkedOrders al correct per orderItem.
  } else {
    // Alles uitvinken
    allCheckboxes.forEach((checkbox) => {
      if (checkbox.checked) checkbox.click();
    });
    setCheckedOrders([]);
  }
};


  const handleChecked = (isChecked, order, orderItem) => {
    setCheckedOrders((prev) => {
      const next = [...prev];
      const oiId = orderItem?.orderItemId;
      const idx = next.findIndex((o) => o.orderId === order.orderId);

      if (isChecked) {
        // ✅ AANVINKEN: voeg toe / markeer item.checked = true
        if (idx === -1) {
          next.push({
            ...order,
            orderItems: order.orderItems.map((oi) =>
              oi.orderItemId === oiId
                ? { ...oi, checked: true }
                : { ...oi, checked: oi.checked || false }
            ),
          });
        } else {
          const o = next[idx];
          next[idx] = {
            ...o,
            orderItems: o.orderItems.map((oi) =>
              oi.orderItemId === oiId ? { ...oi, checked: true } : oi
            ),
          };
        }
      } else {
        // ❌ UITVINKEN: uncheck item; verwijder order als niets meer checked is
        if (idx !== -1) {
          const o = next[idx];
          const updatedItems = o.orderItems.map((oi) =>
            oi.orderItemId === oiId ? { ...oi, checked: false } : oi
          );
          const anyChecked = updatedItems.some((oi) => oi.checked);
          if (anyChecked) {
            next[idx] = { ...o, orderItems: updatedItems };
          } else {
            next.splice(idx, 1);
          }
        }
      }
      return next;
    });
  };

  const handleCanceledOrderItem = async (order, orderItem) => {
    let newOpenOrders = [...openOrders];

    newOpenOrders.forEach((o, index) => {
      if (o.orderId === order.orderId) {
        o.orderItems.forEach((oI, indexJ) => {
          if (oI.orderItemId === orderItem.orderItemId) {
            newOpenOrders[index].orderItems.splice(indexJ, 1);
          }
        });
        if (o.orderItems.length === 0) {
          newOpenOrders.splice(index, 1);
        }
      }
    });

    const slicedOrders = newOpenOrders.slice(offset, offset + perPage);

    for (let order of slicedOrders) {
      if (order.orderItems && order.orderItems.length > 0) {
        for (let orderItem of order.orderItems) {
          let res = await getProductBySku(
            orderItem.offer.reference,
            auth.token
          );
          if (!res) {
            orderItem.productData = false;
          } else {
            orderItem.productData = res.productData;
          }
        }
      }
    }

    setPageCount(Math.ceil(newOpenOrders.length / perPage));
    setOffset(0);
    setOrdersToShow(slicedOrders);
    setOpenOrders(newOpenOrders);
    setRecountOrders(!recountOrders);
  };

  const handleSingleShipOrderConfirmDetails = (orderX) => {
    orderX.orderItems.forEach((item) => {
      if (item.fulfilment.distributionParty === "BOL") {
        item.checked = true;
      }
    });

    setShipOrdersConfirmDetails(orderX);
  };

const searchHandler = (e) => {
  const q = e.target.value.toLowerCase();
  setSearchQuery(e.target.value);

  const source = openOrders || [];
  const matched = source.filter((order) =>
    JSON.stringify(order).toLowerCase().includes(q)
  );

  setFilteredOrders(matched);
  showPage(matched, 0); // ✅ altijd terug naar pagina 1

  // selectie resetten
 Array.from(
   document.querySelectorAll(".o-li-item input, .checkbox-all-orders input")
 ).forEach((cb) => {    if (cb.checked) cb.click();
  });
  setCheckedOrders([]);
};

console.log(checkedOrders);

const downloadMultipleShippingLabelsHandler = async () => {
  setLoadingState("Verzendzegels worden opgehaald");

  if (!checkedOrders || checkedOrders.length <= 0) {
    setLoadingState(false);
    setShowAlertText("Geen bestellingen geselecteerd");
    setTimeout(() => setShowAlertText(false), 3000);
    return;
  }

  const labels = [];

  for (const checkedOrder of checkedOrders) {
    // 👉 Altijd eerst frontend override gebruiken, dan fallback naar chosenOption
    const chosen =
      checkedOrder.frontEndChosenDeliveryOption ||
      checkedOrder.deliveryOptions?.[0]?.chosenOption ||
      null;

    if (chosen && chosen.entityId && checkedOrder.origin?.account) {
      labels.push({
        account: checkedOrder.origin.account,
        labelEntityId: chosen.entityId,
      });
    }
  }

  if (!labels.length) {
    setLoadingState(false);
    setShowAlertText(
      "Geen verzendzegels gevonden voor de geselecteerde orders."
    );
    setTimeout(() => setShowAlertText(false), 3000);
    return;
  }

  const multipleLabelsPdf = await getMultipleShippingLabelsPdf(
    labels,
    auth.token
  );

  setLoadingState(false);

  if (multipleLabelsPdf instanceof Blob) {
    downloadBlobFile(multipleLabelsPdf, moment().format("L-HH-mm"));
  } else {
    console.error("Bulk labels error:", multipleLabelsPdf);
    setShowAlertText("Bulk verzendzegels downloaden mislukt.");
    setTimeout(() => setShowAlertText(false), 3000);
  }
};


// 👉 Deze houdt alle relevante lijsten in sync (ordersToShow, filteredOrders, openOrders, checkedOrders)
const patchOrderWithNewOption = (o, order, updateDeliveryOption) => {
  if (!o) return o;
  // match op id of orderId, afhankelijk van hoe hij in de lijst staat
  if (o.id !== order.id && o.orderId !== order.orderId) return o;

  return {
    ...o,
    // frontend override voor labelkeuze
    frontEndChosenDeliveryOption: updateDeliveryOption,
    // zorg dat de gekozen optie ook in de shipment zit
    deliveryOptions: (o.deliveryOptions || []).map((shipment) => ({
      ...shipment,
      chosenOption: updateDeliveryOption,
    })),
  };
};

const updateOrdersWithDeliveryOption = (updateDeliveryOption, order) => {
  // lijst op huidige pagina
  setOrdersToShow((prev) =>
    (prev || []).map((o) => patchOrderWithNewOption(o, order, updateDeliveryOption))
  );

  // gefilterde lijst (voor paginatie/search)
  setFilteredOrders((prev) =>
    (prev || []).map((o) => patchOrderWithNewOption(o, order, updateDeliveryOption))
  );

  // volledige set openOrders
  setOpenOrders((prev) =>
    (prev || []).map((o) => patchOrderWithNewOption(o, order, updateDeliveryOption))
  );
};

const updateCheckedOrdersWithDeliveryOption = (updateDeliveryOption, order) => {
  setCheckedOrders((prev) =>
    (prev || []).map((o) => patchOrderWithNewOption(o, order, updateDeliveryOption))
  );
};


  const deliveryOptionImgHandler = (deliveryOption) => {
    if (!deliveryOption) return null;
    const label = deliveryOption.toLowerCase();

    if (label.includes("postnl") && label.includes("brievenbus")) {
      return <img src={postnlBolMailbox} alt="PostNL Brievenbus" />;
    }
    if (
      label.includes("postnl") &&
      label.includes("pakket") &&
      label.includes("avond")
    ) {
      return <img src={postnlBolParcelNight} alt="PostNL Avond Pakket" />;
    }
    if (
      label.includes("postnl") &&
      label.includes("pakket") &&
      label.includes("afhaal")
    ) {
      return <img src={postnlBolParcelPickup} alt="PostNL Afhaal Pakket" />;
    }
    if (label.includes("postnl") && label.includes("pakket")) {
      return <img src={postnlBolParcel} alt="PostNL Pakket" />;
    }

    if (label.includes("dhl") && label.includes("brievenbus")) {
      return <img src={dhlBolMailbox} alt="DHL Brievenbus" />;
    }
    if (label.includes("dhl") && label.includes("avond")) {
      return <img src={dhlBolParcelNight} alt="DHL Avond Pakket" />;
    }
    if (label.includes("dhl") && label.includes("afhaal")) {
      return <img src={dhlBolParcelPickup} alt="DHL Afhaal Pakket" />;
    }
    if (label.includes("dhl") && label.includes("pakket")) {
      return <img src={dhlBolParcel} alt="DHL Pakket" />;
    }

    return null; // fallback als niks matcht
  };

  const shipOrdersHandler = async (ordersToProcess) => {
    // Totaal aantal te verzenden items tellen
    const totalItems = ordersToProcess.reduce((acc, o) => {
      const items = Array.isArray(o.orderItems)
        ? o.orderItems.filter((i) => i.checked)
        : [];
      return acc + items.length;
    }, 0);

    if (totalItems === 0) {
      setShowAlertText("Geen bestellingen geselecteerd");
      setTimeout(() => setShowAlertText(false), 3000);
      return;
    }

    let processed = 0;
    const updateProgress = () => {
      setLoadingState(`${processed}/${totalItems} Bestelregels verwerkt`);
    };
    updateProgress();

    // Maak een array met alle taken
    const tasks = [];
    for (const order of ordersToProcess) {
      const account = order?.origin?.account;
      if (!account) continue;

      // Bewaar de gekozen optie (voorkomt ontbrekende data)
      const chosen =
        order?.frontEndChosenDeliveryOption ||
        order?.deliveryOptions?.[0]?.chosenOption ||
        null;
      if (chosen) order.frontEndChosenDeliveryOption = chosen;

      for (const item of order.orderItems || []) {
        if (!item.checked) continue;
        tasks.push({ account, order, item });
      }
    }

    // Voer alle zendingen parallel uit met Promise.allSettled
    const results = await Promise.allSettled(
      tasks.map(async ({ account, order, item }) => {
        try {
          const res = await shipOrderItem(account, auth, order, item);
          processed++;
          updateProgress();
          if (res?.ok && [200, 202, 204].includes(res.status)) {
            return {
              success: true,
              orderId: order.orderId,
              itemId: item.orderItemId,
            };
          } else {
            console.warn("Mislukt:", order.orderId, res?.status, res?.error);
            return { success: false, orderId: order.orderId, error: res?.error };
          }
        } catch (err) {
          console.error("Netwerkfout bij order", order.orderId, err);
          processed++;
          updateProgress();
          return { success: false, orderId: order.orderId, error: err.message };
        }
      })
    );

    // Samenvatten
    const ok = results.filter((r) => r.value?.success).length;
    const fail = totalItems - ok;

    setLoadingState(false);
    setToggleRefetchOrders((prev) => !prev);

    // Reset UI
    document
      .querySelectorAll(".o-li-item input:checked")
      .forEach((cb) => cb.click());
    setCheckedOrders([]);

    // Snackbar
    if (ok > 0 && fail === 0) {
      setShowAlertText(`✅ ${ok} bestellingen succesvol verzonden`);
    } else if (ok > 0 && fail > 0) {
      setShowAlertText(`⚠️ ${ok} gelukt, ${fail} mislukt`);
    } else {
      setShowAlertText(`❌ Geen bestellingen verzonden`);
    }
    setTimeout(() => setShowAlertText(false), 4000);
  };

  const createPackingListPDF = async (orders) => {
    setLoadingState("Paklijst wordt aangemaakt");
    let generatePackingSlip = await generatePdfPackingSlip(auth.token, orders);
    setLoadingState(false);
  };

  return (
    <React.Fragment>
      <div className="title-header title-header-open-orders">
        <span>Bestellingen</span>
        <div>
          <div className="header-refetch-container">
            <Button
              className={refetchRemainingTime && "disableRefetchButton"}
              onClick={() => refetchOpenOrdersHandler()}
            >
              {refetchRemainingTime ? (
                <div className="header-refetch-timer">
                  {refetchRemainingTime}s
                </div>
              ) : (
                <FaSyncAlt />
              )}
            </Button>
          </div>
        </div>
      </div>
      <OrdersHeader recountOrders={recountOrders} />

      <div className="orders-sub-header">
        <div className="orders-sub-header-filter-count">
          ({openOrders ? openOrders.length : 0}){" "}
          <span>bestellingen gefilterd</span>{" "}
        </div>

        <div className="orders-search-wrapper">
          <label className="input-search-icon">
            <GoSearch />
          </label>
          <input
            type="search"
            name="search-form"
            id="search-form"
            className="search-input"
            placeholder="Zoek bestelling..."
            value={searchQuery}
            onChange={(e) => searchHandler(e, openOrders)}
          />
        </div>
        <div className="orders-sub-header-filter-options">
          <DropdownButton
            className="filter-open-orders-dropdown"
            align="end"
            id="dropdown-filter-button"
            title={<BsShopWindow />}
            defaultValue={perPage}
            value={perPage}
            onSelect={(e) => {
              filterOrdersByAccount(e);
            }}
          >
            <Dropdown.Item eventKey={`{"$exists":true}`}>
              Alle accounts
            </Dropdown.Item>
            {props.bolAccounts &&
              props.bolAccounts.map((bolAccount, i) => {
                return (
                  <Dropdown.Item eventKey={bolAccount.accountSaleNumber}>
                    {bolAccount.accountName}
                  </Dropdown.Item>
                );
              })}
          </DropdownButton>
          <DropdownButton
            className="filter-open-orders-dropdown"
            align="end"
            id="dropdown-filter-date-button"
            title={<BsCalendarDate />}
            defaultValue={perPage}
            value={perPage}
            onSelect={(dateRangeString) => {
              let dateRange = JSON.parse(dateRangeString);
              filterOrdersByDate({
                startDate: dateRange.startDate,
                endDate: dateRange.endDate,
              });
            }}
          >
            <Dropdown.Item
              eventKey={JSON.stringify({
                startDate: begin2021,
                endDate: end2099,
              })}
            >
              Alles
            </Dropdown.Item>
            <Dropdown.Item
              eventKey={JSON.stringify({
                startDate: begin2021,
                endDate: endOfToday,
              })}
            >
              T/m vandaag
            </Dropdown.Item>
            <Dropdown.Item
              eventKey={JSON.stringify({
                startDate: startOfTomorrow,
                endDate: end2099,
              })}
            >
              Vanaf morgen
            </Dropdown.Item>
          </DropdownButton>
          <DropdownButton
            className="filter-open-orders-dropdown"
            align="end"
            id="dropdown-sorting-button"
            title={<AiOutlineSortAscending />}
            defaultValue={perPage}
            value={perPage}
            onSelect={(e) => {
              sortOrders(e);
            }}
          >
            <Dropdown.Item eventKey={'{"orderItems.offer.reference":1}'}>
              Productgroep (SKU)
            </Dropdown.Item>
            <Dropdown.Item eventKey={'{"orderPlacedDateTime":-1}'}>
              Besteldatum (Nieuw - Oud)
            </Dropdown.Item>
            <Dropdown.Item eventKey={'{"orderPlacedDateTime":1}'}>
              Besteldatum (Oud - Nieuw)
            </Dropdown.Item>
          </DropdownButton>
        </div>
      </div>
      {((accountFilter && accountFilter !== `{"$exists":true}`) ||
        (dateFilter &&
          JSON.stringify(dateFilter) !==
            `{"startDate":"2021-01-01T00:00:00+01:00","endDate":"2099-12-31T23:59:59+01:00"}`)) && (
        <div className="orders-sub-header-filters">
          <div className="orders-sub-header-filters-title">Filters:</div>

          {accountFilter &&
            accountFilter !== `{"$exists":true}` &&
            props &&
            props.bolAccounts &&
            props.bolAccounts.map((bolAccount) => {
              if (bolAccount.accountSaleNumber === accountFilter) {
                return (
                  <div className="orders-sub-header-filters-item">
                    <div>{bolAccount.accountName}</div>
                    <div className="orders-sub-header-filters-item-close">
                      <FaTimes
                        onClick={() => {
                          sessionStorage.removeItem(
                            "openOrdersFilterByAccount"
                          );
                          setAccountFilter(`{"$exists":true}`);
                        }}
                      />
                    </div>
                  </div>
                );
              }
            })}
          {dateFilter && filetDateNameHandler(dateFilter) !== "Alle orders" && (
            <div className="orders-sub-header-filters-item">
              <div>{filetDateNameHandler(dateFilter)}</div>
              <div className="orders-sub-header-filters-item-close">
                <FaTimes
                  onClick={() => {
                    sessionStorage.removeItem("openOrdersFilterByAccount");
                    setDateFilter({ startDate: begin2021, endDate: end2099 });
                  }}
                />
              </div>
            </div>
          )}
        </div>
      )}
      {sortOrdersFilter && sortOrdersFilter !== `{"orderPlacedDateTime":-1}` && (
        <div className="orders-sub-header-filters">
          <div className="orders-sub-header-filters-title">Sortering:</div>
          <div className="orders-sub-header-filters-item">
            <div>{sortingNameHandler(sortOrdersFilter)}</div>
            <div className="orders-sub-header-filters-item-close">
              <FaTimes
                onClick={() => {
                  sessionStorage.removeItem("openOrdersSorting");
                  setSortOrdersFilter(`{"orderPlacedDateTime":-1}`);
                }}
              />
            </div>
          </div>
        </div>
      )}
      {ordersToShow && (
        <div className="orders-container-header open-orders-container-header orders-container-header-dbb">
          <div className="checkbox-all-orders">
            <Form.Check
              type="checkbox"
              label={selectionText()}
              onClick={handleCheckedAll}
              disabled={!openOrders}
            />
          </div>
          <div className="orders-container-header-dbb-actions">
            <div className="orders-container-header-dbb-actions-buttons">
              {ordersToShow && checkedOrders.length > 0 && (
                <div className="orders-container-header-actions">
                  <Button
                    onClick={() => {
                      downloadMultipleShippingLabelsHandler();
                    }}
                  >
                    Download verzendzegels
                  </Button>
                </div>
              )}
              {ordersToShow && checkedOrders.length > 0 && (
                <div className="orders-container-header-actions">
                  <Button
                    onClick={() => {
                      setShipOrdersConfirmDetails(true);
                    }}
                  >
                    {checkedOrders.length}{" "}
                    {checkedOrders.length === 1
                      ? "Bestelling "
                      : "Bestellingen "}
                    verwerken
                  </Button>
                </div>
              )}
            </div>
            <div className="orders-container-header-dbb-actions-packagelist">
              <DropdownButton
                className="packinglist-dropdown filter-open-orders-dropdown"
                align="end"
                id="dropdown-pickinglist-button"
                title={[<FaPrint />, " Picklijsten"]}
              >
                {checkedOrders && checkedOrders.length > 0 && (
                  <Dropdown.Item
                    onClick={() => {
                      createPackingListPDF(checkedOrders);
                    }}
                  >
                    <FaPrint /> Picklijst geselecteerde orders
                  </Dropdown.Item>
                )}

                {ordersToShow && ordersToShow.length > 0 && (
                  <Dropdown.Item
                    onClick={() => {
                      createPackingListPDF(ordersToShow);
                    }}
                  >
                    <FaPrint />
                    Picklijst huidige pagina
                  </Dropdown.Item>
                )}

                {openOrders && openOrders.length > 0 && (
                  <Dropdown.Item
                    onClick={() => {
                      createPackingListPDF(openOrders);
                    }}
                  >
                    <FaPrint />
                    Picklijst alle orders
                  </Dropdown.Item>
                )}
              </DropdownButton>
            </div>
          </div>
        </div>
      )}
      {errorMessage && (
        <div className="noOrdersContainer">
          <div className="noOrdersText">
            <div className="no-result-search">
              <GoSearch />
              {errorMessage}
            </div>
          </div>
        </div>
      )}
      <div className="orders-container open-orders-container">
        {ordersToShow &&
          ordersToShow.length > 0 &&
          ordersToShow.map((order, i) => {
            return (
              <div
                key={order.orderId}
                className={
                  "o-li-item-container o-li-item-container-dbb" +
                  (order.orderItems && order.orderItems.length > 1
                    ? " multiOrderItems"
                    : "")
                }
              >
                <OrderListItemOpen
                  key={order.id}
                  order={order}
                  distributionParty="DBB"
                  handleChecked={handleChecked}
                  cancelOrderItem={handleCanceledOrderItem}
                  setSingleShipOrderConfirmDetails={
                    handleSingleShipOrderConfirmDetails
                  }
update={(updateDeliveryOption) => {
    updateOrdersWithDeliveryOption(updateDeliveryOption, order);
    updateCheckedOrdersWithDeliveryOption(
      updateDeliveryOption,
      order
    );
  }}
                />
              </div>
            );
          })}
        {ordersToShow && ordersToShow.length === 0 && (
          <div className="noOrdersContainer">
            <div className="noOrdersText">
              {searchQuery === "" ? (
                "Alle orders zijn ingepakt, goed zo!"
              ) : (
                <div className="no-result-search">
                  <GoSearch />
                  Geen resultaat
                </div>
              )}
            </div>
          </div>
        )}
        {loadingState && (
          <div className="loading-container">
            <div className="loading-container-title">{loadingState}</div>
            <RotateLoader
              size={100}
              width={100}
              height={10}
              color={"#fff"}
              loading={loadingState}
            />
          </div>
        )}
      </div>
      {ordersToShow && (
        <ReactPaginate
          previousLabel={"<"}
          nextLabel={">"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={pageCount}
          marginPagesDisplayed={5}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
      {shipOrdersConfirmDetails &&
        (() => {
          let ordersToProcess = [...checkedOrders];

          if (
            shipOrdersConfirmDetails &&
            typeof shipOrdersConfirmDetails !== "boolean"
          ) {
            ordersToProcess = [shipOrdersConfirmDetails];
          }

          return (
            <div className="deliveryOptionsContainer">
              <div className="deliveryOptions">
                <div
                  className="deliveryOptionsCloseButton"
                  onClick={() => {
                    setShipOrdersConfirmDetails(false);
                  }}
                >
                  <FaTimes />
                </div>
                <h1>
                  {ordersToProcess.length}{" "}
                  {ordersToProcess.length === 1
                    ? "Bestelling "
                    : "Bestellingen "}
                  verwerken
                </h1>
                <h5>
                  {(() => {
                    if (ordersToProcess.length === 1) {
                      return (
                        <ol className="orderItemsList">
                          <li>
                            {ordersToProcess[0].orderItems.map((oI, i) => {
                              if (oI.productData && oI.productData.title) {
                                return (
                                  <div>
                                    <span>{i + 1}</span>
                                    {oI.productData.title}
                                  </div>
                                );
                              } else {
                                return (
                                  <div>
                                    <span>{i + 1}</span>
                                    {oI.product.title}
                                  </div>
                                );
                              }
                            })}
                          </li>
                        </ol>
                      );
                    }
                  })()}
                </h5>

                <div className="confirmDeliveryAlertMessageContainer">
                  <div className="confirmDeliveryAlertMessageIconContainer">
                    <FaExclamationTriangle />
                  </div>
                  <div className="confirmDeliveryAlertMessageText">
                    Voor een of meerdere bestellingen verwacht de klant de
                    bestelling op een specifieke datum te ontvangen. Wacht met
                    inleveren van de bestelling tot de aangegeven
                    overdrachtsdatum. <br />
                    <br />
                    Na bevestiging stuurt bol.com de klant een e-mail met de
                    aangegeven leverdatum, de bezorgdienst en het Track & Trace
                    nummer.
                  </div>
                </div>
                {ordersToProcess.map((order) => {
                  order.orderItems.map((orderItem, i) => {
                    return (
                      <div className="deliveryOptionsProduct" key={orderItem.orderItemId || i}>
                        <div className="deliveryOptionsProductTitle">
                          {orderItem.product.title}
                        </div>
                        <div className="deliveryOptionsProductDetails">
                          <span>
                            EAN: {orderItem.product.ean}{" "}
                            <a
                              href={
                                "https://www.bol.com/nl/nl/s/?searchtext=" +
                                orderItem.product.ean
                              }
                              target="_noblank"
                            >
                              <FaExternalLinkAlt />
                            </a>
                          </span>
                          <span>|</span>
                          <span>{orderItem.offer.reference}</span>
                          <span>|</span>
                          <span>
                            {orderItem.quantity}
                            {orderItem.quantity === 1 ? " stuk" : " stuks"}
                          </span>
                          <span>|</span>
                          <span>€ {orderItem.unitPrice * orderItem.quantity}</span>
                        </div>
                      </div>
                    );
                  });
                })}

                <div className="deliveryOptionsHeadBalk">
                  <h1 className="labelTextH1">Verzendzegels</h1>
                  <div>Aantal</div>
                  <div>Prijs</div>
                </div>

                {(() => {
                  let shipmentChoices = [];

                  for (let cOrder of ordersToProcess) {
                    for (let dOption of cOrder.deliveryOptions) {
                      let labelName = dOption.chosenOption.labelDisplayName;
                      if (shipmentChoices.length > 0) {
                        let foundShipmentChoice = false;
                        shipmentChoices.map((deliveryOption, i) => {
                          if (deliveryOption.hasOwnProperty(labelName)) {
                            foundShipmentChoice = true;
                            shipmentChoices[i][labelName].quantity += 1;
                            shipmentChoices[i][labelName].totalPrice +=
                              dOption.chosenOption.labelPrice.totalPrice;
                          }
                        });

                        if (foundShipmentChoice === false) {
                          shipmentChoices.push({
                            [labelName]: {
                              quantity: 1,
                              totalPrice:
                                dOption.chosenOption.labelPrice.totalPrice,
                              packageRestrictions:
                                dOption.chosenOption.packageRestrictions,
                            },
                          });
                        }
                      } else {
                        shipmentChoices.push({
                          [labelName]: {
                            quantity: 1,
                            totalPrice:
                              dOption.chosenOption.labelPrice.totalPrice,
                            packageRestrictions:
                              dOption.chosenOption.packageRestrictions,
                          },
                        });
                      }
                    }
                  }
                  return shipmentChoices.map((shipmentChoice) => {
                    let shipmentChoiceData;
                    for (var choice in shipmentChoice) {
                      shipmentChoiceData = shipmentChoice[choice];
                    }

                    return (
                      <div
                        key={Object.keys(shipmentChoice)[0]}
                        className={"radio-toolbar orderConfirm"}
                      >
                        <Form.Check
                          type="radio"
                          name="chooseDeliveryOptions"
                          label={
                            <div className="deliveryOptionLabelInfoMulti">
                              <div className="deliveryOptionLabelImg">
                                {deliveryOptionImgHandler(
                                  Object.keys(shipmentChoice)[0]
                                )}
                              </div>
                              <div className="deliveryOptionData">
                                <div className="deliveryOptionName">
                                  {Object.keys(shipmentChoice)[0]}
                                </div>
                                <div className="deliveryOptionMeasurements">
                                  <div>
                                    {"< " +
                                      shipmentChoiceData.packageRestrictions
                                        .maxWeight}
                                  </div>
                                  <div className="divider">|</div>
                                  <div>
                                    {"< " +
                                      shipmentChoiceData.packageRestrictions
                                        .maxDimensions}
                                  </div>
                                </div>
                              </div>
                              <div className="deliveryOptionQuantity">
                                {shipmentChoiceData.quantity}
                              </div>
                              <div className="deliveryOptionPrice">
                                €{" "}
                                {shipmentChoiceData.totalPrice
                                  .toFixed(2)
                                  .replace(".", ",")}
                                *
                              </div>
                            </div>
                          }
                        />
                      </div>
                    );
                  });
                })()}
                <div className="deliveryOptionLabelExtraInfo">
                  * Excl. eventueel verschuldigde btw. De zegelkosten verrekenen
                  we automatisch met je opbrengst.
                </div>
                <div className="deliveryOptionButtons">
                  <Button
                    onClick={() => {
                      setShipOrdersConfirmDetails(false);
                    }}
                  >
                    Nee, ga terug
                  </Button>
                  <Button
                    onClick={(e) => {
                      shipOrdersHandler(ordersToProcess);
                      setShipOrdersConfirmDetails(false);
                    }}
                  >
                    Ja, verwerk!
                  </Button>
                </div>
              </div>
            </div>
          );
        })()}
      {showAlertText && <div className="snackbar">{showAlertText}</div>}
      <AssistantToggleButton />
    </React.Fragment>
  );
};

export default OrdersFbrDbb;